import { BusinessContextModel } from '../../../core/model/BusinessContext.model';
import { CpeMonitoredDevicesQuery } from './CpeMonitoredDevicesQuery.config';

export const CpeStatisticsBusinessContextConfig: BusinessContextModel = {
  queries: CpeMonitoredDevicesQuery,
  translateNamespace: 'cpeStatistics'
}